export enum KnowledgeRouteParams {
  // 补充AI无法回复问题 - 知识已启用
  SupplementKnowledgeBootstrap = '1',
  // 补充AI无法回复问题 - AI审核不通过
  SupplementKnowledgeAICheckFailed = '2',
  // 补充AI无法回复问题 - 人工审核不通过&待人工审核
  SupplementKnowledgeManual = '3',
  // 补充AI无法回复问题 - 待人工审核
  SupplementKnowledgeManualPending = '4',
}
